module.exports = __webpack_public_path__ + "img/undraw_login_re_4vu2.4640c347.svg";